import Vue from 'vue'

export default function authInterceptor (config) {
  if (config.skipAuthentification) return config

  const authService = Vue.auth
  if (!authService) {
    throw new Error(
      'AuthService not installed! Make sure to call `Vue.use(AuthService)`.',
    )
  }

  if (authService.isAuthenticated) {
    config.headers['Authorization'] = `Bearer ${authService.accessToken}`
  }

  return config
}
